import mapModule from './map.module.js';

export default mapModule;
